import type { LabelHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  obrigatorio?: boolean;
}

export function Label({ className, obrigatorio, children, ...props }: LabelProps) {
  return (
    <label className={cn('block text-sm font-medium text-slate-700 mb-1', className)} {...props}>
      {children}
      {obrigatorio && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
}
